module.exports = __webpack_public_path__ + "static/img/Logo_GAES.51ff744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/Logo_GAES.png
// module id = 319
// module chunks = 6